var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"book-page"},[_c('div',{staticClass:"page-title"},[_vm._v("订单工具操作手册")]),_vm._v(" "),_c('div',{staticClass:"content-body"},[_c('div',{staticClass:"content-box"},[_c('hll-doc',{attrs:{"data":_vm.handbookInfo}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37661900","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/help/handbook.vue
// module id = 954
// module chunks = 0